<template>

  <div id="qrcode" ref="expCodeRef"   style="position: absolute;margin: auto ;left:50%;"></div>

</template>

<script>
import QRCode from 'qrcodejs2'
export default {
    data() {
    return {
        reportNumber:this.Msg
    }
    },
    props:['Msg'],//接收psMsg值
    mounted(){
        this.qrcode()
    },
    methods:{
         delQrcode(){
          this.$refs.expCodeRef.innerHTML = ""
         },
      qrcode (reportNumber) {
          let qrcodeDiv = document.getElementById('qrcode')
        let qrcode = new QRCode(qrcodeDiv, {
          width: 100,// 宽度
          height: 100, // 高度
        //   text: ('http://45.119.52.226:8090/api/report/' + this.reportNumber), // 二维码内容
        text: ('http://www.tyjc3935.com/#/scanQRCode/' + this.reportNumber), // 二维码内容
          // render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f',
          // foreground: '#ff0',
        })
        console.log('qrcode成功',reportNumber)
        console.log(qrcode)
      },
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/qrcode.vue